import axios from 'axios';

const addTeamDefaultContact = async (
  userId: string,
  selectedTeams?: string[],
) => {
  await axios.post(`/user/default/team/${userId}`, {
    params: { selectedTeams },
  });
};

export default addTeamDefaultContact;
